import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '../css/application.css'

import PointsOnPaymentsRouter from '@pointsOnPayments/Router'
import PointsRouter from '@points/Router'
import PaymentsOnDemandRouter from '@paymentsOnDemand/Router'

import PayBillScreen from '@pointsOnPayments/screens/PayBillScreen'
import SupplierBillScreen from '@pointsOnPayments/screens/SupplierBillScreen'
import ReactComponent from '../react'

import AccountsScreen from '../react/screens/AccountsScreen'
import CustomerInformPaymentNotFoundScreen from '../react/screens/CustomerInformPaymentScreen/NotFound'
import CreatePasswordScreen from '../react/screens/CreatePasswordScreen'
import CustomerInformPaymentScreen from '../react/screens/CustomerInformPaymentScreen'
import CustomerPaymentScreen from '../react/screens/CustomerPaymentScreen'
import LiveStatementScreen from '../react/screens/LiveStatementScreen'
import LoadingCustomerPaymentScreen from '../react/screens/LoadingCustomerPaymentScreen'
import PayerStatementScreen from '../react/screens/PayerStatementScreen'
import DashboardFailureScreen from '../react/screens/DashboardScreen/Failure'
import DisconnectionSupplierScreen from '../react/screens/DisconnectionScreen/Supplier'
import LogoutScreen from '../react/screens/LogoutScreen'
import ResendUnlockScreen from '../react/screens/ResendUnlockScreen'
import ResetPasswordScreen from '../react/screens/ResetPasswordScreen'
import SettingsScreen from '../react/screens/SettingsScreen'
import SignInScreen from '../react/screens/SignInScreen'
import SignUpContactUsScreen from '../react/screens/SignUpContactUsScreen'
import SignUpScreen from '../react/screens/SignUpScreen'
import NewSupplierCashInScreen from '../react/screens/NewSupplierCashInScreen'
import SupplierDirectPaymentsScreen from '../react/screens/SupplierDirectPaymentsScreen'
import SupplierInvoiceScreen from '../react/screens/SupplierInvoiceScreen'
import SupplierPaymentsScreen from '../react/screens/SupplierPaymentsScreen'
import {
  SupplierRequestClosureScreen,
  SupplierRequestClosureConfirmationScreen,
} from '../react/screens/SupplierRequestClosure'

import setDineroDefaults from '../utils/dineroDefaults'

setDineroDefaults()

const routers = {
  PointsOnPaymentsRouter,
  PointsRouter,
  PaymentsOnDemandRouter,
}

ReactComponent.setup({
  ...routers,
  AccountsScreen,
  CreatePasswordScreen,
  CustomerInformPaymentNotFoundScreen,
  CustomerInformPaymentScreen,
  CustomerPaymentScreen,
  LiveStatementScreen,
  LoadingCustomerPaymentScreen,
  PayerStatementScreen,
  DashboardFailureScreen,
  DisconnectionSupplierScreen,
  LogoutScreen,
  ResendUnlockScreen,
  ResetPasswordScreen,
  PayBillScreen,
  SettingsScreen,
  SignInScreen,
  SignUpContactUsScreen,
  SignUpScreen,
  NewSupplierCashInScreen,
  SupplierDirectPaymentsScreen,
  SupplierInvoiceScreen,
  SupplierBillScreen,
  SupplierRequestClosureScreen,
  SupplierRequestClosureConfirmationScreen,
  SupplierPaymentsScreen,
})
